import { MixpanelProps } from "../constants/mixpanel";
import { getTimezoneCountryISO } from "./country";
import config from "../config";
import { AppPlatform } from "../constants";

export const SocialProofTestVariations = {
	CONTROL: "control", // control group
	REMOVE_SHAKE: "remove-shake",
	LARGER_BUTTON: "larger-button",
	SOCIAL_PROOF_POPUP: "social-proof-popup",
	COPY_CHANGE: "copy-change",
};

export const getSocialProofPopupVersion = (socialProofTest) => {
	return socialProofTest === SocialProofTestVariations.SOCIAL_PROOF_POPUP
		? "A"
		: "NA";
};

export const getSocialProofDelay = (
	socialProofTest,
	socialProofPopupDelay,
	isMobile
) => {
	console.log({ socialProofTest, socialProofPopupDelay, isMobile });

	if (socialProofTest !== SocialProofTestVariations.SOCIAL_PROOF_POPUP) {
		return -1;
	}

	if (isMobile) {
		return socialProofPopupDelay;
	}

	return -1;
};

export const getSocialProofTestProps = ({
	buttonCta,
	count = 0,
	isMobile,
	testsData,
}) => {
	return {
		[MixpanelProps.GLUTEN_FREE_COUNT_IN_AREA_SHOWN]: count >= 100,
		// [MixpanelProps.SOCIAL_PROOF_TEST_BUTTON_ANIMATION]:
		// 	testsData?.tests?.socialProofTest ===
		// 	SocialProofTestVariations.REMOVE_SHAKE
		// 		? "NA"
		// 		: "shake with 3s delay",
		// [MixpanelProps.SOCIAL_PROOF_TEST_BUTTON_SIZE]:
		// 	testsData?.tests?.socialProofTest ===
		// 	SocialProofTestVariations.LARGER_BUTTON
		// 		? "60px"
		// 		: "48px",
		[MixpanelProps.SOCIAL_PROOF_TEST_BUTTON_CTA]: buttonCta,
		[MixpanelProps.SOCIAL_PROOF_TEST_BUTTON_DESTINATION]:
			testsData?.tests?.ctaTarget,
		// [MixpanelProps.SOCIAL_PROOF_TEST_VARIATION]:
		// 	testsData?.tests?.socialProofTest,
		// [MixpanelProps.SOCIAL_PROOF_TEST_SOCIAL_PROOF_POPUP_VERSION]:
		// 	getSocialProofPopupVersion(testsData?.tests?.socialProofTest),
		// [MixpanelProps.SOCIAL_PROOF_TEST_SOCIAL_PROOF_POPUP_DELAY]:
		// 	getSocialProofDelay(
		// 		testsData?.tests?.socialProofTest,
		// 		testsData?.tests?.socialProofPopupDelay,
		// 		isMobile
		// 	),
	};
};

export const fetchFeatureFlags = async ({ flagNames = [], query = {}, id }) => {
	const countryISO = getTimezoneCountryISO();
	const url = new URL(config.api.address);
	url.pathname += "/steps3/autls/feature-flags";
	url.searchParams.append("distinct_id", id);
	url.searchParams.append("country", countryISO);
	url.searchParams.append("query", JSON.stringify(query));

	flagNames.forEach((flagName) => {
		url.searchParams.append("known_features", flagName);
	});

	try {
		const response = await fetch(url.toString(), {
			method: "GET",
			headers: {
				app_version: config.version.path,
				app_platform: AppPlatform.LP,
			},
		});

		const data = await response.json();
		return data.feature_flags;
	} catch (error) {
		console.error("Error:", error);
		return false;
	}
};
